const ResetDeviceIcon = ({ className, title }) => (
  <svg
    aria-hidden={title ? undefined : 'true'}
    className={className}
    fill='none'
    height='22'
    role={title ? 'img' : undefined}
    viewBox='0 0 22 22'
    width='22'
    xmlns='http://www.w3.org/2000/svg'
  >
    {title && <title>{title}</title>}
    <path
      d='M17.4 7.2A7.2 7.2 0 1 0 18 13'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.8'
    />
    <path
      d='M17.6 2.8V7.4H13'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.8'
    />
  </svg>
)

export default ResetDeviceIcon
